import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { LeadSection } from './components/LeadSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionsFailSection } from './components/SolutionsFailSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductIntro } from './components/ProductIntro';
import { IncludesSection } from './components/IncludesSection';
import { OriginStory } from './components/OriginStory';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { RiskReversal } from './components/RiskReversal';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-charcoal text-offwhite font-sans selection:bg-sand/30 selection:text-sand" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <LeadSection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <SolutionsFailSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <ProductIntro data-id="element-8" />
        <IncludesSection data-id="element-9" />
        <OriginStory data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <ForWhomSection data-id="element-12" />
        <RiskReversal data-id="element-13" />
        <UrgencySection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}